var map = {
	"./nor0.png": 213798,
	"./nor1.png": 982543,
	"./nor2.png": 60084,
	"./nor3.png": 281213,
	"./nor4.png": 588418,
	"./nor5.png": 352075,
	"./nor6.png": 386672,
	"./nor7.png": 102425,
	"./nor8.png": 286862,
	"./nor9.png": 760503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895960;